exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bid .bid-body[data-v-6ad97d5a]{width:90%;margin:0 auto}.bid .bid-left[data-v-6ad97d5a]{background:hsla(0,0%,100%,.3);border-radius:.4rem;padding:.48rem .8rem}.bid .bid-right[data-v-6ad97d5a]{min-height:8.64rem}.bid .bid-title[data-v-6ad97d5a]{font-size:.32rem;font-weight:500;color:#1f1f1f;line-height:.38rem;margin-bottom:.4rem}", ""]);

// exports
